import names from '../actions/actionNames';
import initialState from '../initialState';

const progressReducers = (state = initialState.progress, action) => {
  switch (action.type) {
    case names.LOADING_STARTED:
      return Object.assign({}, state, {
        isLoading: true
      });
    case names.LOADING_FINISHED:
      return Object.assign({}, state, {
        isLoading: false
      });
    default:
      return state;
  }
};

export default progressReducers;
